import React from 'react';
import './ConnectSection.css';

const ConnectSection = ({ title, subtitle, items, onItemClick, onViewAllClick }) => {
  return (
    <div className="connect-section container py-4 px-3 mb-4 bg-white rounded-4 shadow-sm">
      <div className="d-flex justify-content-between align-items-start mb-4 px-2 border-start border-primary-purple ps-3">
        <div className="ps-2">
          <h3 className="fw-bold mb-1 text-dark" style={{ fontSize: '1.5rem' }}>{title}</h3>
          <p className="text-secondary small mb-0">{subtitle}</p>
        </div>
        <button className="btn view-all-btn rounded-pill px-4 py-1" onClick={onViewAllClick}>
          View all <i className="bi bi-chevron-right ms-2" style={{ fontSize: '0.8rem' }}></i>
        </button>
      </div>

      <div className="row g-3 px-2 flex-nowrap overflow-auto hide-scrollbar">
        {items.map((item, index) => (
          <div
            key={index}
            className={`col-4 col-sm-3 col-md-2 text-center${onItemClick ? ' cursor-pointer' : ''}`}
            style={{ minWidth: '120px' }}
            onClick={() => onItemClick && onItemClick(item)}
          >
            <div className="connect-img-container mb-2">
              <img src={item.image} alt={item.label} className="img-fluid rounded-4" />
            </div>
            <p className="connect-label small fw-bold text-secondary mb-0 px-1" style={{ fontSize: '0.85rem', lineHeight: '1.2' }}>
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ConnectSection;
